export default "/images/0fa822e77d7bdaf2d4e80ef25459ef76.avif";